import { createSlice } from "@reduxjs/toolkit";

const policyListSlice = createSlice({
  name: "policyList",
  initialState: {
    allMonthlyPolicyReport: [],
  },
  reducers: {
    setAllMonthlyPolicyReport: (state, action) => {
      state.allMonthlyPolicyReport = action?.payload;
    },
    clearAllMonthlyPolicyReport: (state) => {
      state.allMonthlyPolicyReport = [];
    },
  },
});

export const { setAllMonthlyPolicyReport, clearAllMonthlyPolicyReport } =
  policyListSlice.actions;
export default policyListSlice.reducer;
